export const blockIconsTextformattingArchiveNew = (
	<span className='material-symbols-outlined'>archive</span>
);
